module.exports = __webpack_public_path__ + "static/logo-coloradobiz-topcompany-eab548bce1d19c08a02a9ee8e6057a26.png";